import { createApi } from '@reduxjs/toolkit/query/react';
import { waServicesQuery } from '@/store/baseQueries';

export interface DashboardMessageRecord {
  AdvisorGroupMessageId: number;
  Message: string;
}

export interface DashboardMessagesData {
  Records: DashboardMessageRecord[];
  TotalLength: number;
  SummedValues: unknown;
}

export interface RemoveDashboardMessageRequest {
  advisorGroupMessageId: number;
}

export const dashboardMessagesApi = createApi({
  reducerPath: 'dashboardMessagesApi',
  baseQuery: waServicesQuery,
  tagTypes: ['DashboardMessages'],
  endpoints: (builder) => ({
    getDashboardMessages: builder.query<DashboardMessagesData, void>({
      query: () => ({
        url: '/api/user/DashboardMessages',
        method: 'GET',
      }),
      providesTags: ['DashboardMessages'],
    }),
    removeDashboardMessage: builder.mutation<
      void,
      RemoveDashboardMessageRequest
    >({
      query: ({ advisorGroupMessageId }) => ({
        url: `/api/user/DashboardMessages/${advisorGroupMessageId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['DashboardMessages'],
    }),
  }),
});

export const {
  useGetDashboardMessagesQuery,
  useRemoveDashboardMessageMutation,
} = dashboardMessagesApi;
